import RecordingField from '../recordingfield'
import { getCode } from '@core/utils/codes'
import UserToken from '@admin/tokens/user'
import Form from '@admin/components/form'
import SpeakField from '../speakfield'
import PropTypes from 'prop-types'
import React from 'react'

class User extends React.PureComponent {

  static contextTypes = {
    form: PropTypes.object
  }

  static propTypes = {
    user: PropTypes.object,
    mode: PropTypes.string,
    users: PropTypes.array,
    onDone: PropTypes.func
  }

  static defaultProps = {
    user: {}
  }

  state = {
    config: null
  }

  _handleBack = this._handleBack.bind(this)
  _handleChange = this._handleChange.bind(this)
  _handleDone = this._handleDone.bind(this)

  render() {
    if(!this.state.config) return null
    return <Form { ...this._getForm() } />
  }

  componentDidMount() {
    const { user } = this.props
    this.setState({
      config: {
        ...this._getDefault(),
        ...user
      }
    })
  }

  _getDefault() {
    return {
      code: getCode(10),
      strategy: 'none'
    }
  }

  _getForm() {
    const { mode } = this.props
    const { config } = this.state
    return {
      title: 't(Recipient)',
      cancelSvg: 'chevron_left',
      onCancel: this._handleBack,
      onChange: this._handleChange,
      onSuccess: this._handleDone,
      saveText: mode === 'new' ? 'Add' : 'Update',
      sections: [
        {
          fields: [
            { name: 'code', type: 'hidden', value: config.code },
            { label: 't(Announcement)', type: 'segment', instructions: 'Play this announcement before dialing out to recipient)', fields: [
              { name: 'strategy', type: 'radiogroup', options: [
                { value: 'none', text: 't(No announcement)' },
                { value: 'say', text: 't(Speak text)' },
                { value: 'play', text: 't(Play an audio file)' }
              ], defaultValue: config.strategy },
              ...this._getStrategy()
            ] },
            { label: 't(User)', type: 'segment', fields: [
              { name: 'user_id', type: 'lookup', required: true, prompt: 't(Choose User)', endpoint: '/api/admin/users', filter: { is_active: { $eq: true } }, valueKey: 'id', textKey: 'full_name', format: UserToken, defaultValue: config.user_id }
            ] }
          ]
        }
      ]
    }
  }

  _getStrategy() {
    const { config } = this.state
    if(config.strategy === 'say') {
      return [
        { name: 'say', type: SpeakField, placeholder: 'Connecting you to...', required: true, defaultValue: config.say }
      ]
    }
    if(config.strategy === 'play') {
      return [
        { name: 'recording_id', type: RecordingField, required: true, defaultValue: config.recording_id }
      ]
    }
    return []
  }

  _handleBack() {
    this.context.form.pop()
  }

  _handleChange(config) {
    this.setState({ config })
  }

  _handleDone() {
    const { config } = this.state
    this.props.onDone(config)
    this.context.form.pop()
  }

}

export default User
